import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";

// Types e Actions creators
const { Types, Creators } = createActions({
  consultaCepRequest: ["cep"],
  consultaCepSuccess: ["data"],
  consultaCepFailure: ["error"],
  consultaCepReset: [],
});

export const consultaCepTypes = Types;
export default Creators;

// Initial state
export const INITIAL_STATE = {
  data: null,
  loading: false,
  error: null,
};

// Reducers
export const consultaCepRequest = state => {
  return update(state, {
    loading: { $set: true },
    error: { $set: null },
  });
};

export const consultaCepSuccess = (state, action) => {
  const { data } = action;
  return update(state, {
    data: { $set: data },
    loading: { $set: false },
    error: { $set: null },
  });
};

export const consultaCepFailure = (state, action) => {
  const { error } = action;
  return update(state, {
    loading: { $set: false },
    error: { $set: error },
  });
};

export const consultaCepReset = state => {
  return INITIAL_STATE;
}

// Reducers to Types
export const reducer = createReducer(INITIAL_STATE, {
  [Types.CONSULTA_CEP_REQUEST]: consultaCepRequest,
  [Types.CONSULTA_CEP_SUCCESS]: consultaCepSuccess,
  [Types.CONSULTA_CEP_FAILURE]: consultaCepFailure,
  [Types.CONSULTA_CEP_RESET]: consultaCepReset,
});
